module.exports = __webpack_public_path__ + "static/media/news-full-background-card.eb3a8c9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news-full-background-card.png
// module id = 1003
// module chunks = 0